/**
 * WordPress dependencies.
 */
import { render, Fragment, useState } from '@wordpress/element';
import domReady from '@wordpress/dom-ready';
import { Panel, PanelBody, Disabled, Notice, TabPanel } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { applyFilters, addFilter } from '@wordpress/hooks';
import { compose } from '@wordpress/compose';
import { withSelect, withDispatch } from '@wordpress/data';
import { getFragment } from '@wordpress/url';
import { store as coreStore } from '@wordpress/core-data';

/**
 * Exteranl dependencies.
 */
import { replace, isEmpty } from 'lodash';

/**
 * Inner dependencies.
 */
import GeneralTab from './tab-content/general';
import '../extensions/store/settings';
import DesignTab from './tab-content/design';

addFilter( 'gutenify-admin-settings', 'gutenify/admin/settings/heading', ( content, props ) => (
	[ ...content, <Fragment key="gutenify-admin-settings-heading">
		<h1>{ __( 'Gutenify Settings' ) }</h1>
		<p className="description">{ __( 'If you need any help please contact us from our support page.' ) }</p>
		<TabPanel
			className="gutenify-setting-tab-panel"
			activeClass="active-tab"
			// orientation='vertical'
			// onSelect={ ( tabName ) => {
			// 	console.log( 'Selecting tab', tabName );
			// } }
			initialTabName="general"
			tabs={ [
				{
					name: 'general',
					title: __( 'General' ),
					className: 'tab-one',
				},
				{
					name: 'design',
					title: __( 'Design' ),
					className: 'tab-two',
				},
			] }
		>
			{ ( tab ) => {
				return <>
					{ 'general' === tab.name && <GeneralTab { ...props } /> }
					{ 'design' === tab.name && <DesignTab { ...props } /> }
				</>;
			} }
		</TabPanel>
	</Fragment> ]
) );

addFilter( 'gutenify-admin-settings', 'gutenify/admin/settings/notice', ( content, props ) => (
	[ ...content, <div className="gutenify-setting-panel-notice-area" key="gutenify-admin-settings-notice">
		{ ! isEmpty( props.appState.settingError ) && '' !== props.appState.settingError && <Notice status="error" onRemove={ () => {
			props.setAppState( ( prevState ) => {
				return {
					...prevState,
					settingError: '',
				};
			} );
		} }>{ props.appState.settingError }</Notice> }
		{ ! isEmpty( props.appState.settingSuccess ) && '' !== props.appState.settingSuccess && <Notice status="success" onRemove={ () => {
			props.setAppState( ( prevState ) => {
				return {
					...prevState,
					settingSuccess: '',
				};
			} );
		} }>{ props.appState.settingSuccess }</Notice> }
	</div> ]
) );

const App = ( props ) => {
	const [ appState, setAppState ] = useState( {
		hasSettingChange: false,
		isSettingsDisabled: false,
		settingError: '',
		settingSuccess: '',
	} );

	const updateSettings = ( settings ) => {
		setAppState( ( prev ) => {
			return {
				...prev,
				hasSettingChange: true,
			};
		} );
		props.setSettings( settings );
	};

	const changeSiteOptions = ( options ) => {
		props.updateSiteOptions( options );
	};

	const urlFragment = getFragment( window.location.href );
	const activePanel = replace( urlFragment, '#', '' );

	return <Disabled isDisabled={ appState.isSettingsDisabled }>
		{ applyFilters( 'gutenify-admin-settings', [], { ...props, setAppState, appState, updateSettings, activePanel, changeSiteOptions } ) }
	</Disabled>;
};

const AppCompose = compose( withSelect( ( select ) => {
	const { getSettings, getSiteOptions } = select( 'gutenify/settings' );
	const siteOptions = getSiteOptions();
	console.log( siteOptions );
	const coreSelect = select( coreStore );
	// return {
	// 	// siteOptions: { ...getSiteOptions() },
	// };
	return {
		styleId: coreSelect.__experimentalGetCurrentGlobalStylesId(),
		gStyle: coreSelect.__experimentalGetCurrentThemeBaseGlobalStyles(),
		settings: getSettings(),
		siteOptions: getSiteOptions(),
	};
} ),
withDispatch( ( dispatch ) => {
	const { setSettings, updateSiteOptions } = dispatch( 'gutenify/settings' );
	return {
		setSettings,
		updateSiteOptions,
	};
} ) )( App );

domReady( function() {
	const appID = 'gutenify-settings-app';
	if ( 'undefined' !== typeof document.getElementById( appID ) && null !== document.getElementById( appID ) ) {
		render( <AppCompose />, document.getElementById( appID ) );
	}
} );
